<template>
  <div class="modal-content confirme-cancel-reason">
    <div class="modal-body">
      <div class="row text-center animated fadeInDown">
        <div class="col-lg-12">
          <div class="m-b-md">
            <h2 class="font-bold">Êtes-vous sûr de vouloir annuler cette commande ?</h2>
            <p class="text-center reasaon">{{ model.title }}</p>
            <div class="col-lg-12">
              <button type="button"
                      class="btn btn-danger"
                      @click="closeModal">Annuler</button>
              <button type="button"
                      class="btn btn-primary"
                      @click="onConfirm">Valider</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    data: () => ({
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },
      commandId () {
        return store.order.id
      },
    },

    methods: {
      onConfirm () {
        store.order.id = this.commandId
        this.$bus.$emit(`reason-confirm-success`)
        this.$apollo.mutate({
          mutation: this.model.cancelReason
        }).then(() => {
          this.closeModal()
          this.showBanner('success', `Succès: la commande # ${this.commandId} a bien été annulée`)
          setTimeout(function () {
            location.reload(true)
          }, 500)
        }, () => {
          this.closeModal()
          this.showBanner('danger', `La commande # ${this.commandId} n'a pas pu être annulée`)
        })
      }
    }
  }
</script>
